/* Tech2000s — interactive behaviors for redesign sections */
(function () {
  'use strict';

  // ----- Device video play/pause toggles (PSP / Vita / DS) -----
  document.querySelectorAll('[data-t2k-device]').forEach(function (device) {
    var video = device.querySelector('video');
    var playBtn = device.querySelector('[data-t2k-play]');
    var progress = device.querySelector('[data-t2k-progress]');

    if (!video) return;

    // Try to start it (autoplay muted should be allowed)
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});

    function syncBtn() {
      if (!playBtn) return;
      playBtn.classList.toggle('is-playing', !video.paused);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });
    }
    video.addEventListener('play', syncBtn);
    video.addEventListener('pause', syncBtn);
    video.addEventListener('timeupdate', function () {
      if (progress && video.duration) {
        progress.style.width = (video.currentTime / video.duration * 100) + '%';
      }
    });
    syncBtn();
  });

  // ----- iPod player -----
  document.querySelectorAll('[data-t2k-ipod]').forEach(function (root) {
    var tracks = JSON.parse(root.getAttribute('data-tracks') || '[]');
    if (!tracks.length) return;

    var idx = 0;
    var playing = false;
    var audio = new Audio();
    audio.preload = 'metadata';

    var artEl = root.querySelector('[data-ipod-art]');
    var titleEl = root.querySelector('[data-ipod-title]');
    var artistEl = root.querySelector('[data-ipod-artist]');
    var curEl = root.querySelector('[data-ipod-current]');
    var totalEl = root.querySelector('[data-ipod-total]');
    var fillEl = root.querySelector('[data-ipod-fill]');
    var statusEl = root.querySelector('[data-ipod-status]');
    var playBtn = root.querySelector('[data-ipod-play]');
    var nextBtn = root.querySelector('[data-ipod-next]');
    var prevBtn = root.querySelector('[data-ipod-prev]');
    var menuBtn = root.querySelector('[data-ipod-menu]');
    var centerBtn = root.querySelector('[data-ipod-center]');

    function fmtTime(s) {
      if (!isFinite(s)) return '0:00';
      var m = Math.floor(s / 60);
      var ss = Math.floor(s % 60);
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }

    function loadTrack(i) {
      var t = tracks[i];
      audio.src = t.src || '';
      if (artEl)    artEl.style.backgroundImage = t.art ? 'url(' + t.art + ')' : '';
      if (titleEl)  titleEl.textContent = t.title || 'Untitled';
      if (artistEl) artistEl.textContent = t.artist || '';
      if (statusEl) statusEl.textContent = playing ? 'Now Playing' : 'iPod';
      if (curEl)    curEl.textContent = '0:00';
      if (totalEl)  totalEl.textContent = '0:00';
      if (fillEl)   fillEl.style.width = '0%';
    }

    function play() {
      if (!audio.src) return;
      var p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(function () { playing = false; updateUI(); });
      playing = true; updateUI();
    }
    function pause() { audio.pause(); playing = false; updateUI(); }
    function toggle() { playing ? pause() : play(); }
    function next() { idx = (idx + 1) % tracks.length; loadTrack(idx); play(); }
    function prev() { idx = (idx - 1 + tracks.length) % tracks.length; loadTrack(idx); play(); }

    function updateUI() {
      if (!playBtn) return;
      playBtn.textContent = playing ? 'ⅡⅡ' : '▶';   // ⏸ vs ▶
      if (statusEl) statusEl.textContent = playing ? 'Now Playing' : 'iPod';
    }

    audio.addEventListener('loadedmetadata', function () {
      if (totalEl) totalEl.textContent = fmtTime(audio.duration);
    });
    audio.addEventListener('timeupdate', function () {
      if (curEl) curEl.textContent = fmtTime(audio.currentTime);
      if (fillEl && audio.duration) fillEl.style.width = (audio.currentTime / audio.duration * 100) + '%';
    });
    audio.addEventListener('ended', next);

    if (playBtn) playBtn.addEventListener('click', toggle);
    if (centerBtn) centerBtn.addEventListener('click', toggle);
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (menuBtn) menuBtn.addEventListener('click', function () {
      // tap menu = subtle wheel rotation feedback
      root.querySelector('.t2k-wheel').animate(
        [{ transform: 'rotate(0deg)' }, { transform: 'rotate(8deg)' }, { transform: 'rotate(0deg)' }],
        { duration: 240, easing: 'ease-out' }
      );
    });

    loadTrack(0);
  });

  // ----- Reveal-on-scroll for cards & headings -----
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.animation = 't2k-fade-up 0.8s cubic-bezier(0.22,1,0.36,1) both';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.t2k-card, .t2k-brand__title, .t2k-brand__sub, .t2k-device').forEach(function (el) {
      io.observe(el);
    });
  }
})();

// ----- Free shipping bars: cart drawer, cart page, site banner -----
(function(){
  var KEY = 't2k_banner_dismissed_until';
  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return (cents/100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents/100).toFixed(2); }
  }

  function updateInstance(d, cart) {
    // Bars pegged to a fixed USD threshold are driven by currency-converter.js
    if (window.CurrencyConverter && (d.hasAttribute('data-cc-shipbar') || d.querySelector('[data-cc-shipbar]'))) return;
    var threshold = parseInt(d.getAttribute('data-shipping-threshold'), 10) || 0;
    if (!threshold) return;
    var total = cart.total_price;
    var msg = d.querySelector('[data-t2k-shipbar-msg]');
    var fill = d.querySelector('[data-t2k-shipbar-fill]');
    var pct = Math.min(100, Math.round(total / threshold * 100));

    if (cart.item_count === 0) {
      d.classList.remove('is-complete');
      if (fill) {
        fill.style.width = '0%';
        fill.removeAttribute('data-low');
      }
      var threshMoney = d.getAttribute('data-threshold-money') || fmt(threshold);
      if (msg) msg.innerHTML = '<span aria-hidden="true">✦</span> FREE WORLDWIDE SHIPPING ON ORDERS OVER <strong>' + threshMoney + '</strong>';
    } else if (total >= threshold) {
      d.classList.add('is-complete');
      if (fill) {
        fill.style.width = '100%';
        fill.removeAttribute('data-low');
      }
      if (msg) msg.innerHTML = '<strong>✓ You unlocked free shipping</strong>';
    } else {
      d.classList.remove('is-complete');
      if (fill) {
        fill.style.width = pct + '%';
        if (pct < 30 && pct > 0) fill.setAttribute('data-low', 'true');
        else fill.removeAttribute('data-low');
      }
      var remaining = threshold - total;
      if (msg) msg.innerHTML = "You're <strong>" + fmt(remaining) + '</strong> away from FREE SHIPPING';
    }
  }

  function update() {
    var nodes = document.querySelectorAll('[data-t2k-cart-drawer]');
    if (!nodes.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        nodes.forEach(function(n){ updateInstance(n, cart); });
      })
      .catch(function(){});
  }

  function applyDismissed() {
    try {
      var until = parseInt(localStorage.getItem(KEY) || '0', 10);
      if (until && Date.now() < until) {
        document.querySelectorAll('[data-t2k-banner]').forEach(function(b){ b.classList.add('is-hidden'); });
      }
    } catch(e) {}
  }
  applyDismissed();

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-t2k-banner-close]');
    if (!btn) return;
    var banner = btn.closest('[data-t2k-banner]');
    if (banner) banner.classList.add('is-hidden');
    try { localStorage.setItem(KEY, String(Date.now() + 60 * 60 * 1000)); } catch(e) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  document.addEventListener('cart:updated', update);

  var origFetch = window.fetch;
  window.fetch = function(){
    var args = arguments;
    return origFetch.apply(this, args).then(function(res){
      try {
        var url = args[0] && args[0].toString ? args[0].toString() : '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(update, 250);
        }
      } catch (e) {}
      return res;
    });
  };
})();

// ----- Mobile sticky ATC -----
(function(){
  var bar = document.querySelector('[data-t2k-mobile-atc]');
  if (!bar) return;
  var trigger = bar.querySelector('[data-t2k-mobile-atc-trigger]');
  // Find the real product form's submit button
  function findBuyBtn() {
    return document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
  }
  // Show when scrolled past the buy area
  var io;
  function setup() {
    var btn = findBuyBtn();
    if (!btn) return;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(btn);
    }
    if (trigger) {
      trigger.addEventListener('click', function(){
        btn.click();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

// ----- Recently viewed (localStorage) -----
(function(){
  var KEY = 't2k_recent';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }

  // Track a product handle on product pages
  function track() {
    var meta = document.querySelector('meta[property="og:url"], link[rel="canonical"]');
    var path = window.location.pathname;
    var m = path.match(/\/products\/([a-z0-9_-]+)/i);
    if (!m) return;
    var handle = m[1];
    var list = read().filter(function(h){ return h !== handle; });
    list.unshift(handle);
    write(list);
  }
  track();

  // Render into recently-viewed section if present
  var section = document.querySelector('[data-t2k-recent-section]');
  if (!section) return;
  var grid = section.querySelector('[data-t2k-recent-grid]');
  if (!grid) return;
  var excludeHandle = section.getAttribute('data-exclude');
  var handles = read().filter(function(h){ return h !== excludeHandle; }).slice(0, 4);
  if (!handles.length) return;

  // Fetch each product's JSON and build a mini-card
  Promise.all(handles.map(function(h){
    return fetch('/products/' + h + '.js').then(function(r){return r.ok ? r.json() : null;}).catch(function(){return null;});
  })).then(function(prods){
    var html = prods.filter(Boolean).map(function(p){
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var price = (p.price/100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      return '<a class="t2k-card" href="/products/' + p.handle + '">' +
               '<div class="t2k-card__media">' +
                 (img ? '<img src="' + img + '" alt="' + (p.title||'') + '" loading="lazy">' : '') +
                 '<span class="t2k-card__quickview">View →</span>' +
               '</div>' +
               '<div class="t2k-card__body">' +
                 '<h3 class="t2k-card__title">' + (p.title||'') + '</h3>' +
                 '<p class="t2k-card__price">' + price + '</p>' +
               '</div>' +
             '</a>';
    }).join('');
    if (html) {
      grid.innerHTML = html;
      section.classList.add('is-visible');
    }
  });
})();
